import { useEffect, useState } from 'react';
import { useQuery, useMutation } from 'react-query';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import { getSettings, updateSettings } from '../../queries/settings';
import { setSettings } from '../../store/settingsSlice';
import NavTabs from '../../components/shikky/components/NavTabs';
import PanelAccount from './PanelAccount';
import PanelShifts from './PanelShifts';
import PanelLogs from './PanelLogs';
import PanelSettings from './PanelSettings';
import getLogs from '../../queries/logs';
import { setLogs } from '../../store/logsSlice';

export const daysNames = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
export const parseSettingsData = data => {
  return {
    bufferTime: data.user_buffer_time.minutes,
    dayFilters: data.user_day_filters.map((_, key) => {
      const { day, start, end, rejectAll } = data.user_day_filters.find(({ day }) => day === daysNames[key]);
      return { day, start, end, rejectAll };
    }),
    hasAPaidSubscription: data.hasAPaidSubscription,
    notificationEnabled: data.notificationEnabled,
    paypalSubscriptionPrice: data.paypalSubscriptionPrice,
    enabled: data.enabled,
    subscription: data.subscription,
  };
};

const DashboardPage = () => {
  const [selectedTab, setSelectedTab] = useState(0);
  const user = useSelector(state => state.authentication.user);
  const token = useSelector(state => state.authentication.token);
  const settings = useSelector(state => state.settings.settings);
  var logs = useSelector(state => state.logs.logs);
  const { data: settingsData, refetch: refetchSettings } = useQuery('settings', () => getSettings(token, user), {
    cacheTime: 0,
  });
  const { data: logsData, refetch } = useQuery('todos', () => getLogs(token, user));
  const dispatch = useDispatch();
  const enabled = settings?.enabled;

  const updateSettingsQuery = useMutation(updateSettings, {
    useErrorBoundary: true,
  });

  useEffect(() => {
    if (user.localTimezone === null) {
      updateSettingsQuery.mutateAsync({
        token,
      });
    }
    return () => dispatch(setSettings(null));
  }, [dispatch]);

  useEffect(() => {
    if (settingsData) {
      dispatch(setSettings(parseSettingsData(settingsData)));
    }
  }, [dispatch, settingsData]);

  useEffect(() => {
    if (logsData) {
      dispatch(setLogs(logsData));
    }
  }, [dispatch, logsData]);

  useEffect(() => {
    const intervalId = setInterval(() => {
      if (enabled) refetch();
    }, 5000);
    return () => clearInterval(intervalId);
  }, [enabled, refetch]);

  if (!logs) logs = [];
  // logs = [
  //   {
  //     id: 8723,
  //     timestamp: '31/12/2021 22:36:51',
  //     shiftWeekDay: 'Sunday',
  //     shiftDay: '02/01',
  //     shiftStartTime: '06:00 PM',
  //     shiftEndTime: '10:00 PM',
  //     status: 'ACCEPTED',
  //     user: {
  //       id: 55,
  //       username: 'thiagohenryy@outlook.com',
  //       email: 'thiagohenryy@outlook.com',
  //       provider: 'local',
  //       resetPasswordToken: null,
  //       confirmationToken: null,
  //       confirmed: true,
  //       blocked: false,
  //       role: 1,
  //       token: 'f6c93c85-e35a-4d53-8456-4f58ff6d7b2a',
  //       userID: 'c4748a34-49b0-4c20-bb24-1dd0aff720df',
  //       created_by: 2,
  //       updated_by: 2,
  //       created_at: '2021-12-02T23:42:14.346Z',
  //       updated_at: '2022-05-17T08:28:15.230Z',
  //       user_buffer_time: 35,
  //       enabled: true,
  //       notificationToken: null,
  //       notificationEnabled: true,
  //       phoneNumber: '+447985149850',
  //       citiesInitialized: true,
  //       domain: 'wejustgrab',
  //       unauthorized: true,
  //       verifiedPhoneNumber: null,
  //       isPhoneNumberVerified: null,
  //       otp: null,
  //       OTP: null,
  //       stripeCustomerId: null,
  //       hasAPaidSubscription: true,
  //       vehicle: null,
  //     },
  //     created_by: {},
  //     updated_by: null,
  //     created_at: '2021-12-31T22:36:51.938Z',
  //     updated_at: '2022-01-17T19:21:11.119Z',
  //     shiftID: '43489d83-0216-4900-a8d5-af899be31134',
  //     reason: null,
  //     location: 'Glasgow - South',
  //     vehicle: 'bicycle',
  //   },
  // ];
  const fixTime = (time, day) => {
    const date = moment(moment.utc(`${day} ${time}`, 'DD/MM HH:mm A').format());
    return [date.format('HH:mm A'), date.format('DD/MM')];
  };

  logs = [...logs].map(({ timestamp, shiftWeekDay, shiftDay, shiftStartTime, shiftEndTime, created_at }) => {
    const [startTime, startDay] = fixTime(shiftStartTime, shiftDay);
    const [endTime] = fixTime(shiftEndTime, shiftDay);
    return {
      title: `Accepted on ${shiftWeekDay} @ ${timestamp.substr(-8)}`,
      date: startDay,
      timeStart: startTime,
      timeEnd: endTime,
      created_at,
    };
  });

  const shifts = [...logs];
  return settings ? (
    <NavTabs
      selectedTab={selectedTab}
      setSelectedTab={setSelectedTab}
      contents={{
        play: (
          <PanelShifts
            settings={settings}
            selectedTab={selectedTab}
            setSelectedTab={setSelectedTab}
            shifts={shifts}
            refetchSettings={refetchSettings}
            user={user}
          />
        ),
        user: <PanelAccount user={user} settings={settings} />,
        cog: <PanelSettings settings={settings} />,
        list: <PanelLogs logs={logs} />,
      }}
    />
  ) : (
    <></>
  );
};

export default DashboardPage;
